

export const addCategoryEndpoint = () =>(`/api/category`);

export const editCategoryEndpoint = (categoryId: string) =>
 (`/api/category/${categoryId}`);

export const getCategoryEndpoint = () =>(`/api/category`);

export const getCategorytDetailsEndpoint = (categoryId: string) =>
 (`/api/category/${categoryId}`);

export const deleteCategoryEndpoint = (categoryId: string) =>
 (`/api/category/${categoryId}`);